// The Mapbox popup a picked difficult section opens (see sectionHighlights.ts).
// Kept apart so the components that use it can be tested without Mapbox.
import mapboxgl from 'mapbox-gl';
import { CALLOUT_CLASS } from './sectionHighlights';
import type { SectionPopup } from './sectionHighlights';

export function createSectionPopup(): SectionPopup {
  return new mapboxgl.Popup({
    className: CALLOUT_CLASS,
    closeButton: false,
    closeOnClick: true,
    offset: 14,
    maxWidth: 'none',
  }) as unknown as SectionPopup;
}
